import { createReducer } from "@reduxjs/toolkit";
import {
  getQuestionaryListSuccess,
  loadingList,
  setProcedureId,
} from "./questionaryActions";

export interface IQuestionaryState {
  questionaryList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  ProcedureId: number;
}

const initialState: IQuestionaryState = {
  questionaryList: [],
  dataCount: 0,
  isLoading: false,
  ProcedureId: 0,
};

export const questionyReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getQuestionaryListSuccess, (state, action) => {
      state = {
        ...state,
        questionaryList: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })

    .addCase(loadingList, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(setProcedureId, (state, action) => {
      state = {
        ...state,
        ProcedureId: action.payload,
      };
      return state;
    });
});
